import styled from 'styled-components';
import theme from '../../../../styles/defaultTheme';
import * as Styles from '../styles';

export const Container = styled(Styles.Container)`
    ${({ isTitle }) => {
        if (isTitle) {
            return `
                border: none;
                text-transform: uppercase;
                font-weight: bold;
            `;
        }

        return `border: 1px solid black;`;
    }}
`;

export const Check = styled.div`
    display: flex;
    align-items: center;

    padding: 0 5px;

    margin-bottom: 2px;
`;

export const Square = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;

    min-width: 18px;
    height: 8px;
    background: #cccccc9e;

    border: 1px solid #CCC;

    margin-right: 5px;

    ${({ checked }) => {
        if (checked) {
            return `
                &:after {
                    margin-top: -3px;
                    content: "X";
                    font-size: ${theme.font.size5};
                }
            `;
        }

        return ``;
    }}
`;

export const Label = styled.div`
    font-size: ${theme.font.size6};
    white-space: nowrap;

    ${({ isTitle }) => {
        if (isTitle) {
            return `
                text-transform: uppercase;
                font-weight: bold;
            `;
        }

        return ``;
    }}
`;
